import React, { useCallback, useEffect } from 'react';
import './Pay.scss';
import { DataGrid, Button, LoadPanel, Popup, Form } from 'devextreme-react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import GlobalParams from '../../helpers/GlobalParams.js';
import { Column } from 'devextreme-react/cjs/data-grid.js';
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import { ButtonItem, ButtonOptions, Item, Label, RequiredRule } from 'devextreme-react/cjs/form.js';

const Pay = () => {

  const [debitsData, setDebitsData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [amount, setAmount] = React.useState(0);

  const emptyItemConfig = {
    itemType: 'empty',
  };

  const [popupPromptVisible, setPopupPromptVisible] = React.useState(false);
  const [promptStore, setPromptStore] = React.useState({
    amount: 0,
    mobile: '',
  });
  const hidePromptButtonClick = () => {
    setPopupPromptVisible(false);
  }



  const fetchDebits = async () => {
    try {
      //use axios to fetch data get
      const response = await axios.get(
        GlobalParams.ApiUrlPrefix + "client-debit-notes?gc_id=" + GlobalParams.ClientId,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );
      setIsLoading(false);
      setDebitsData(response.data.data);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  }

  useEffect(() => {
    setIsLoading(true);
    fetchDebits();
  }, []);

  const doSendPrompt = useCallback(async (e) => {
    e.preventDefault();
    notify('Payment prompt sent to: +254' + promptStore.mobile, 'success', 5000);
    setPopupPromptVisible(false);
  }, [promptStore]);

  return (
    <div>
      <LoadPanel visible={isLoading} />

      {/*create a pop up - display the amount and phone number to send the prompt to*/}
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupPromptVisible}
          title={'Send MPesa Payment Prompt'}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hidePromptButtonClick}
        >

          <div>
            <form onSubmit={doSendPrompt}>
              <Form formData={promptStore}>

                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <Item
                  dataField="amount"
                  editorType="dxNumberBox"
                  editorOptions={
                    {
                      readOnly: true,
                      value: amount,
                      /*onValueChanged: (e) => {
                        setPromptStore((state) => {
                          return ({ ...state, amount: e.value })
                        });
                      }*/
                    }
                  }
                >
                  <RequiredRule message="Amount is required" />
                  <Label text='Amount' />
                </Item>

                <Item
                  dataField="mobile"
                  editorType="dxTextBox"
                  editorOptions={
                    {
                      readOnly: false,
                      onValueChanged: (e) => {
                        setPromptStore((state) => {
                          return ({ ...state, mobile: e.value })
                        });
                      },
                      mask: '+254 (X00) 000-000',
                      maskRules: { X: /[02-9]/ }
                    }
                  }
                >
                  <RequiredRule message="Mobile is required" />
                  <Label text='Mobile' />
                </Item>

                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <ButtonItem
                >
                  <ButtonOptions type='danger' text="SEND MPESA PROMPT" icon='money' useSubmitBehavior={true} />
                </ButtonItem>

              </Form>
            </form>
          </div>

        </Popup>
      </div>
      <br></br>
      <div style={{ color: '#2E86C1', fontWeight: 'bold' }}>OutStanding Debits</div>
      {
        <DataGrid
          dataSource={debitsData}
          wordWrapEnabled={true}
          searchPanel={
            {
              visible: true,
              width: 250
            }
          }
        >
          <Column dataField="PolicyCompany" groupIndex={0}></Column>
          <Column dataField="schemeNo" visible={false}></Column>
          <Column dataField="reference"></Column>
          <Column dataField="trans_date" dataType='date'></Column>
          <Column dataField="gross_amount" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.gross_amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }}> </Column>
          <Column cellRender={(cellInfo) => {
            return (
              <div>
                <Button
                  text="Pay Via Mpesa"
                  type='default'
                  icon='money'
                  onClick={
                    () => {
                      //notify('Payment prompt sent to: 0725068143', 'success', 5000);
                      setAmount(cellInfo.data.gross_amount);
                      setPopupPromptVisible(true);
                    }
                  }
                />
              </div>
            );
          }}>
          </Column>
        </DataGrid>
      }
    </div>
  );
}
export default Pay;